import { mdiDeleteForever, mdiFileEdit } from "@mdi/js";
import {
  OptGrid,
  OptGridColumn,
  OptGridOptions,
  OptGridRef,
  OptGridRequest,
  OptGridResponse,
} from "@optsol/react";
import React from "react";
import { Colors } from "../../../compartilhado/colors";
import { OptGridContainer } from "../../../componentes/OptGridContainer";
import { ItemSearchResponse } from "../../../modelos/dtos/ItemSearchResponse";

interface Props {
  onRowClick: (rowData?: ItemSearchResponse) => void;
  carregar: (
    data: OptGridRequest
  ) => Promise<OptGridResponse<ItemSearchResponse>>;
  onClickDelete: (rowData: ItemSearchResponse) => void;
  onClickEdit: (rowData: ItemSearchResponse) => void;
  gridRef: React.MutableRefObject<OptGridRef | null>;
}

const options: OptGridOptions = {
  search: true,
  pageSize: 10,
};

export const GridItensView = React.forwardRef<OptGridRef | undefined, Props>(
  (
    {
      carregar,
      onRowClick,
      onClickDelete,
      onClickEdit,
      gridRef,
    },
    ref
  ) => {
    const columns: OptGridColumn<ItemSearchResponse>[] = [
      {
        title: "Id",
        field: "id",
        align: "left",
        hidden: true,
      },
      {
        title: "Código",
        field: "codigo",
        align: "left",
        hidden: false,
        width: 200,
      },
      {
        title: "Descrição",
        field: "descricao",
        align: "left",
        hidden: false,
        width: 15,
      }
    ];

    function adicionarPercentual(valor: number): string {
      return valor + "%";
    }

    return (
      <>
        <OptGridContainer>
          <OptGrid
            title=""
            ref={gridRef}
            columns={columns}
            data={carregar}
            options={options}
            onRowClick={onRowClick}
            actionsPosition={"end"}
            actions={[
              (rowData) => ({
                icon: {
                  path: mdiFileEdit,
                  size: 1,
                  color: Colors.gray,
                },
                tooltip: "Editar cupom",
                onClick: () => onClickEdit(rowData),
                disabled: false,
              }),
              (rowData) => ({
                icon: {
                  path: mdiDeleteForever,
                  size: 1,
                  color: Colors.red2,
                },
                tooltip: "Exluir cupom",
                onClick: () => onClickDelete(rowData),
                disabled: false,
              }),
            ]}
          />
        </OptGridContainer>
      </>
    );
  }
);
